import React from 'react';
import { Box } from '@mui/material';
import { useSafeArea } from '../hooks/useSafeArea';

interface SafeAreaViewProps {
  children: React.ReactNode;
  edges?: ('top' | 'bottom' | 'left' | 'right')[];
}

export const SafeAreaView: React.FC<SafeAreaViewProps> = ({ 
  children, 
  edges = ['top', 'bottom', 'left', 'right']
}) => {
  const { top, right, bottom, left } = useSafeArea();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        pt: edges.includes('top') ? top : 0,
        pr: edges.includes('right') ? right : 0,
        pb: edges.includes('bottom') ? bottom : 0,
        pl: edges.includes('left') ? left : 0,
      }}
    >
      {children}
    </Box>
  );
};
